var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisitor = function SvgVisitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.669 13.339a2.966 2.966 0 0 1 2.965-2.966h3.406a2.966 2.966 0 0 1 2.966 2.966M4.669 8.003H1.334M2.668 6.67 1.334 8.004l1.334 1.334"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.337,
    cy: 5.502,
    r: 2.835,
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
};
export { SvgVisitor as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDQ2NDRkNTZhYjE2Mzc2NTdjYjIyYzljZGVhY2FkMjQuc3ZnIjs=";